import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  viboImage: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    borderRadius: '4px',

    '&.isPickable': {
      cursor: 'pointer',
    },

    '& img, & .gradient': {
      width: 'inherit',
      height: 'inherit',
    },

    '& .cornerIcon': {
      color: 'var(--primary-main)',
      position: 'absolute',
      top: '6px',
      right: '6px',
      pointerEvents: 'none',
      backgroundColor: 'var(--primary-lighty)',
      borderRadius: '4px',
      padding: '4px',

      '& svg': {
        margin: 'auto',
      },

      '& span': {
        position: 'absolute',
        bottom: '16px',
        fontSize: '16px',
        fontWeight: 500,
        color: 'var(--background-paper)',
      },

      '@media screen and (min-width: 1441px) ': {
        top: '8px',
        right: '8px',
        padding: '6px',
      },
    },
  },

  imagePlaceholder: {
    objectFit: 'cover',
    backgroundColor: 'var(--background-photo)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--text-primary)',
    width: '100%',
    height: '100%',

    '& span': {
      position: 'absolute',
      bottom: '16px',
      fontSize: '16px',
      fontWeight: 500,
      color: 'inherit',
    },
  },

  removeImageBtn: {
    position: 'absolute',
    right: '15px',
    top: '15px',

    '&.viboButton': {
      padding: '6px',
      height: 'auto',
      border: 'none',
      backgroundColor: 'rgba(255,255,255,.5)',

      '&.defaultDisplay:hover,&:active,&:focus': {
        border: 'none',
      },
    },
  },
}));

export default useStyles;
